import { render, staticRenderFns } from "./Vendas3MesesdoAno.vue?vue&type=template&id=6a06642e&scoped=true&"
import script from "./Vendas3MesesdoAno.vue?vue&type=script&lang=js&"
export * from "./Vendas3MesesdoAno.vue?vue&type=script&lang=js&"
import style0 from "./Vendas3MesesdoAno.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Vendas3MesesdoAno.vue?vue&type=style&index=1&id=6a06642e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06642e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
